import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import TroubleshootingMainLink from './TroubleshootingMainLink.vue'
registerVueComponentAndAngularBindings('troubleshooting:link', 'troubleshootingMainLink', TroubleshootingMainLink)

import TroubleshootingMainPage from './TroubleshootingMainPage.vue'
registerVueComponentAndAngularBindings('troubleshooting:page', 'troubleshootingMainPage', TroubleshootingMainPage)